'use client';
import React, { useEffect } from 'react';
import { isMobile } from '@benzinga/device-utils';
import styled from '@benzinga/themetron';
import { CoreImage } from './CoreImage';
import classnames from 'classnames';
import { usePermission } from '@benzinga/user-context';
import { NoFirstRender } from '@benzinga/hooks';

interface ResponsiveImageBlockProps {
  attrs: {
    className?: string;
    data: {
      image_desktop: any;
      image_mobile: any;
      hide_from_edge?: boolean;
    };
  };
}

export const ResponsiveImageBlock: React.FC<ResponsiveImageBlockProps> = ({ attrs }) => {
  const desktopImage = attrs?.data?.image_desktop;
  const mobileImage = attrs?.data?.image_mobile;
  const className = attrs?.className;
  const hideFromEdge = attrs?.data?.hide_from_edge ?? false;
  const hasPermission = usePermission('com/read', 'unlimited-calendars');
  const [hideImage, setHideImage] = React.useState<boolean>(false);

  useEffect(() => {
    if (hideFromEdge && hasPermission) {
      setHideImage(true);
    }
  }, [hasPermission, hideFromEdge]);

  if ((!desktopImage && !mobileImage) || hideImage) return <div />;
  return (
    <Container className={classnames('responsive-image-block', { [`${className}`]: !!className })}>
      <NoFirstRender>
        <CoreImage block={isMobile() ? mobileImage : desktopImage} />
      </NoFirstRender>
    </Container>
  );
};

const Container = styled.div`
  &.responsive-image-block {
    display: block;
  }
`;
